module.exports = __webpack_public_path__ + "static/media/404.9910b2ca.png";